import i18next from 'i18next';
import { RuleValue } from '@react-awesome-query-builder/core';

export function shouldBeApositiveNumber(val: RuleValue) {
  if (val >= 0) {
    return null;
  }

  return i18next
    .t('validation.default.number.moreThan', {
      value: val,
      min: 0,
    })
    .toString();
}
